import React, { useEffect, useState } from 'react';
import { FmlxButton, FmlxIcon } from 'fmlx-common-ui';
import 'components/bottombar/BottomMenu.scss';
import ReactTooltip from 'react-tooltip';

interface Props {
  valueList: Array<any>;
  selectedValue: string | number | null;
  onValueChange?: (value: number, direction?: 'next' | 'previous') => void;
  onPreviousSelect?: (value: number | null) => void;
  onNextSelect?: (value: number | null) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLElement>) => void;
  sort?: boolean;
  toolTip?: string;
  className?: string;
  disableArrowNavigation?: boolean;
  disabled?: boolean;
  id?: string;
}
export default function BottomMenuSelector(props: Props) {
  const {
    valueList,
    selectedValue,
    onValueChange,
    onPreviousSelect,
    onNextSelect,
    onKeyDown,
    sort,
    toolTip,
    disabled = false,
    id,
  } = props;
  let values = [];
  //if (!valueList)
  values = [...valueList];
  if (sort !== false) {
    values = values.sort((v1, v2) => v1.id - v2.id);
  }

  const [value, setValue] = useState(null);
  const [optionsList, setOptionsList] = useState([]);
  useEffect(() => {
    setValue(selectedValue);
    if (
      // optionsList.length === 0 &&
      valueList !== undefined &&
      valueList.length > 0
    ) {
      values = [...valueList];
      if (sort !== false) {
        values = values.sort((v1, v2) => v1.id - v2.id);
      }
      setOptionsList(
        values.map((val) => (
          <option key={val.id} value={val.id}>
            {val.name}{' '}
          </option>
        )),
      );
    }
  }, [props]);

  useEffect(() => {
    ReactTooltip.rebuild();
  }, []);

  function handleChange(e) {
    setValue(e.target.value);

    if (onValueChange) {
      onValueChange(e.target.value);
    }
  }

  function selectPreviousValue(e) {
    if (onPreviousSelect !== undefined) {
      onPreviousSelect(value);
      return;
    }
    const index = values.findIndex((num) => num.id == value);
    let arrIndex = (index - 1) % values.length;
    if (index === 0) {
      arrIndex = values.length - 1;
    }
    const newValue = values[arrIndex].id;
    setValue(newValue);
    if (onValueChange) {
      onValueChange(newValue, 'previous');
    }
  }

  function selectNextValue(e) {
    if (onNextSelect !== undefined) {
      onNextSelect(value);
      return;
    }
    const index = values.findIndex((num) => num.id == value);
    const newValue = values[(index + 1) % values.length].id;
    setValue(newValue);
    if (onValueChange) {
      onValueChange(newValue, 'next');
    }
  }

  return (
    <>
      {' '}
      <div
        id={id ?? 'bottommenuselector-main-div'}
        data-testid={id ?? 'bottommenuselector-main-div'}
        className="mx-0 contents"
        data-tip={toolTip}
      >
        <FmlxButton
          id="bottommenuselector-previous-button"
          data-testid="bottommenuselector-previous-button"
          onClick={selectPreviousValue}
          size={FmlxButton.Size.MEDIUM}
          type={FmlxButton.Type.BASIC}
          icon={<FmlxIcon name="Previous" />}
          onlyIcon={true}
          withTooltip={false}
          disabled={disabled}
          onKeyDown={onKeyDown}
        />
        {props.disabled ? (
          <div
            id="bottommenuselector-dropdown-button-disabled"
            data-testid="bottommenuselector-dropdown-button-disabled"
            className="selectStyle-disabled"
          >
            Loading...
          </div>
        ) : (
          <select
            id="bottommenuselector-dropdown-button"
            data-testid="bottommenuselector-dropdown-button"
            className="selectStyle"
            value={selectedValue}
            onChange={handleChange}
            onKeyDown={onKeyDown}
          >
            {optionsList}
          </select>
        )}

        <FmlxButton
          id="bottommenuselector-next-button"
          data-testid="bottommenuselector-next-button"
          onClick={selectNextValue}
          size={FmlxButton.Size.MEDIUM}
          type={FmlxButton.Type.BASIC}
          icon={<FmlxIcon name="Next" />}
          onlyIcon={true}
          withTooltip={false}
          disabled={disabled}
          onKeyDown={onKeyDown}
        />
      </div>
    </>
  );
}
